var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading.cardLoading,
              expression: "loading.cardLoading",
            },
          ],
          attrs: { gutter: 16 },
        },
        [
          _c(
            "el-col",
            { staticClass: "mb-18", attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
            [
              _c("reportChart", {
                staticStyle: { height: "195px" },
                attrs: {
                  config: _vm.teamTarget,
                  custom: {
                    height: "195px",
                    slotText: true,
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "left",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "info-wrap" }, [
                          _c("p", { staticClass: "info-title" }, [
                            _vm._v(_vm._s(_vm.$t("merits-board::teamGmv"))),
                          ]),
                          _c("div", { staticClass: "info-number" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  _vm.$dataCheck(
                                    _vm.formatNumberMix(
                                      _vm.perforTarget.teamGmv,
                                      2
                                    ),
                                    "-"
                                  )
                                )
                            ),
                          ]),
                          _c("div", { staticClass: "info-next" }, [
                            _c("div", { staticClass: "info-left" }, [
                              _c("span", { staticClass: "ring" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("merits-board::teamTarget")) +
                                  " "
                              ),
                            ]),
                            _vm.perforTarget.teamTarget
                              ? _c("div", { staticClass: "info-right" }, [
                                  _vm._v(
                                    " $" +
                                      _vm._s(
                                        _vm.$dataCheck(
                                          _vm.formatNumberMix(
                                            _vm.perforTarget.teamTarget,
                                            2
                                          ),
                                          0
                                        )
                                      ) +
                                      " "
                                  ),
                                ])
                              : _c("div", { staticClass: "info-right" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("merits-board::暂未设置目标")
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.push(
                                            "/operate-config?type=target"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "config-manager::operate-config::目标配置"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                          ]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "mb-18", attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
            [
              _c("reportChart", {
                staticStyle: { height: "195px" },
                attrs: { config: _vm.personalTarget },
                scopedSlots: _vm._u([
                  {
                    key: "left",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "info-wrap" }, [
                          _c("p", { staticClass: "info-title" }, [
                            _vm._v(_vm._s(_vm.$t("merits-board::gmv"))),
                          ]),
                          _c("div", { staticClass: "info-number" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  _vm.$dataCheck(
                                    _vm.formatNumberMix(
                                      _vm.perforTarget.gmv,
                                      2
                                    ),
                                    "-"
                                  )
                                )
                            ),
                          ]),
                          _c("div", { staticClass: "info-next" }, [
                            _c("div", { staticClass: "info-left" }, [
                              _c("span", { staticClass: "ring" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("merits-board::target")) +
                                  " "
                              ),
                            ]),
                            _vm.perforTarget.target
                              ? _c("div", { staticClass: "info-right" }, [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        _vm.formatNumberMix(
                                          _vm.perforTarget.target,
                                          2
                                        )
                                      )
                                  ),
                                ])
                              : _c("div", { staticClass: "info-right" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("merits-board::暂未设置目标")
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.push(
                                            "/operate-config?type=target"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "config-manager::operate-config::目标配置"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                          ]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-card", [
        _c(
          "div",
          { staticClass: "search-wrap" },
          [
            _c(
              "div",
              [
                _c("el-cascader", {
                  staticStyle: { width: "250px" },
                  attrs: {
                    options: _vm.teams,
                    clearable: "",
                    placeholder: _vm.$t(
                      "config-manager::operate-config::请选择团队"
                    ),
                    props: {
                      value: "id",
                      label: "name",
                      children: "children",
                      checkStrictly: true,
                    },
                    appendToBody: false,
                  },
                  on: { change: _vm.freshData },
                  model: {
                    value: _vm.team,
                    callback: function ($$v) {
                      _vm.team = $$v
                    },
                    expression: "team",
                  },
                }),
                _c("el-date-picker", {
                  staticClass: "ml-16",
                  attrs: {
                    type: "month",
                    clearable: false,
                    "value-format": "yyyy-MM",
                    format: "yyyy-MM",
                    appendToBody: false,
                  },
                  on: { change: _vm.freshData },
                  model: {
                    value: _vm.params.dtMonth,
                    callback: function ($$v) {
                      _vm.$set(_vm.params, "dtMonth", $$v)
                    },
                    expression: "params.dtMonth",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.$router.push("/merits-board-detail")
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("merits-board::查看详情")) + " ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-row",
        { staticClass: "row-flex", attrs: { gutter: 18 } },
        [
          _c(
            "el-col",
            {
              staticClass: "col-flex",
              attrs: { lg: 8, md: 24, sm: 24, xl: 8 },
            },
            [
              _c(
                "reportTable",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading.teamLoading,
                      expression: "loading.teamLoading",
                    },
                  ],
                  attrs: { config: _vm.teamConfig },
                  on: { change: _vm.changeTeamType },
                },
                [
                  _vm.drowText.length
                    ? _c(
                        "div",
                        { attrs: { slot: "other" }, slot: "other" },
                        _vm._l(_vm.drowText, function (item, index) {
                          return _c(
                            "a",
                            {
                              key: item.id,
                              on: {
                                click: function ($event) {
                                  return _vm.upTeam(index)
                                },
                              },
                            },
                            [
                              _vm._v(" " + _vm._s(item.name) + " "),
                              index < _vm.drowText.length - 1
                                ? _c(
                                    "span",
                                    { staticStyle: { margin: "0 8px" } },
                                    [_vm._v("-")]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: _vm.$t("merits-board::排名"),
                      width: "70",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: _vm.$t("merits-board::名称"),
                      "min-width": "100px",
                      showOverflowTooltip: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.thirdLevelGroupId !== undefined
                              ? _c("span", [_vm._v(_vm._s(row.name))])
                              : _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.drowTeam(row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(row.name))]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.teamType === 1
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "gmv",
                          label: _vm.$t("merits-board::成交额") + "($)",
                          "min-width": "100px",
                          showOverflowTooltip: "",
                        },
                      })
                    : _c("el-table-column", {
                        attrs: {
                          prop: "process",
                          label: _vm.$t("merits-board::目标达成") + "(%)",
                          "min-width": "100px",
                          showOverflowTooltip: "",
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "col-flex",
              attrs: { lg: 8, md: 24, sm: 24, xl: 8 },
            },
            [
              _c(
                "reportTable",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading.campLoading,
                      expression: "loading.campLoading",
                    },
                  ],
                  attrs: { config: _vm.campConfig },
                  on: { change: _vm.changeCampType },
                },
                [
                  _vm.drowText.length
                    ? _c("div", {
                        staticStyle: { height: "18px" },
                        attrs: { slot: "other" },
                        slot: "other",
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: _vm.$t("merits-board::排名"),
                      width: "70",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: _vm.$t("merits-board::名称"),
                      "min-width": "100px",
                      showOverflowTooltip: "",
                    },
                  }),
                  _vm.campType === 1
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "gmv",
                          label: _vm.$t("merits-board::成交额") + "($)",
                          "min-width": "100px",
                          showOverflowTooltip: "",
                        },
                      })
                    : _c("el-table-column", {
                        attrs: {
                          prop: "process",
                          label: _vm.$t("merits-board::目标达成") + "(%)",
                          "min-width": "100px",
                          showOverflowTooltip: "",
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "col-flex",
              attrs: { lg: 8, md: 24, sm: 24, xl: 8 },
            },
            [
              _c(
                "reportTable",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading.shopLoading,
                      expression: "loading.shopLoading",
                    },
                  ],
                  attrs: { config: _vm.shopConfig },
                },
                [
                  _vm.drowText.length
                    ? _c("div", {
                        staticStyle: { height: "18px" },
                        attrs: { slot: "other" },
                        slot: "other",
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: _vm.$t("merits-board::排名"),
                      width: "70",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: _vm.$t("merits-board::名称"),
                      "min-width": "100px",
                      showOverflowTooltip: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "gmv",
                      label: _vm.$t("merits-board::成交额") + "($)",
                      "min-width": "100px",
                      showOverflowTooltip: "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("reportCard", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading.dataLoading,
                expression: "loading.dataLoading",
              },
            ],
            attrs: { config: _vm.dataConfig },
            on: { change: _vm.changeData },
            scopedSlots: _vm._u([
              {
                key: "search",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "mt-16" },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "mr-16",
                            attrs: {
                              placeholder: _vm.$t("merits-board::typeHolder"),
                            },
                            on: { change: _vm.getDataConfig },
                            model: {
                              value: _vm.dataParams.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataParams, "type", $$v)
                              },
                              expression: "dataParams.type",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("merits-board::分时趋势"),
                                value: 1,
                                disabled: _vm.dataParams.measure.some(function (
                                  i
                                ) {
                                  return ["ad_total_fee", "roi"].includes(i)
                                }),
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("merits-board::分日趋势"),
                                value: 2,
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("merits-board::分月趋势"),
                                value: 3,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-select",
                          {
                            staticClass: "mr-16",
                            attrs: {
                              placeholder: _vm.$t("merits-board::请选择标签"),
                              multiple: "",
                              "multiple-limit": 2,
                            },
                            on: { change: _vm.getDataConfig },
                            model: {
                              value: _vm.dataParams.measure,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataParams, "measure", $$v)
                              },
                              expression: "dataParams.measure",
                            },
                          },
                          _vm._l(_vm.tags, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: {
                                label: item.label,
                                value: item.value,
                                disabled:
                                  (item.value == "ad_total_fee" ||
                                    item.value == "roi") &&
                                  _vm.dataParams.type === 1,
                              },
                            })
                          }),
                          1
                        ),
                        _c("el-date-picker", {
                          attrs: {
                            type: "daterange",
                            "range-separator": "-",
                            "value-format": "yyyy-MM-dd",
                            format: "yyyy-MM-dd",
                          },
                          on: { change: _vm.getDataConfig },
                          model: {
                            value: _vm.dataParams.dt,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataParams, "dt", $$v)
                            },
                            expression: "dataParams.dt",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }